export default "__VITE_ASSET__CGrYAVxA__"